import React from "react";

export function GalleryImage({
  src,
  alt = "",
  className = "",
  priority = false,
}) {
  return (
    <img
      src={src || "/placeholder.png"}
      alt={alt}
      className={className}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
    />
  );
}